import { FC } from "react";
import {BuilderIO} from "./BuilderIO";
export interface PageAboutProps {
  className?: string;
}
const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return <BuilderIO />
};
export default PageAbout;